import useUpdateUserLastVisit from "features/app/components/UpdateUserLastVisit/hooks/useUpdateUserLastVisit";

type Props = {
  initialized: boolean;
  children: React.ReactElement;
};

export default function UpdateUserLastVisit({ initialized, children }: Props) {
  useUpdateUserLastVisit({ initialized });
  return children;
}
